var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", [
    _c("div", { staticClass: "footer_wrap" }, [
      _c("p", [
        _vm._v("\n            © SAMSUNG\n            "),
        _c("span", { staticClass: "link" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:" },
              on: { click: _vm.openPrivacyPopup }
            },
            [_vm._v("Privacy")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link_site" }, [
      _c("ul", [
        _c("li", [
          _c("picture", [
            _c("source", {
              attrs: {
                srcset: "/static/images/logo_footer-mo.png",
                media: "(max-width: 767px)"
              }
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                srcset: "/static/images/logo_footer.png",
                media: "(max-width: 1023px)"
              }
            }),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: "/static/images/logo_footer.png",
                alt: "SAMSUNG SKP"
              }
            })
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-307d7947", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307d7947","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/ASCFooter.vue
// module id = GqAG
// module chunks = 0